import localforage from 'localforage';

export default {
    data() {
        return {
            db_playedGames: null
        }
    },
    mounted() {
        this.initDb();
    },
    methods: {
        initDb() {
            let dbName = 'games_db';

            this.db_playedGames = localforage.createInstance({
                name: dbName,
                storeName: 'played_games'
            });
            
            localforage.setDriver([localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE]);

            this.getAllGamesId();
        },
        getAllGamesId() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({post: "1"}));

            axios
            .post(this.$store.state.apiUrl+"?request=getAllGamesId", formData)
            .then((response) => {
                if(response.data.length > 0) {
                    let self = this;
                    this.db_playedGames.iterate(function(value, key) {
                        // Si une ligne du storage n'existe plus dans la base de données
                        if(!response.data.includes(key)) {
                            self.db_playedGames.removeItem(key);
                        }
                    });
                }
            });
        }
    }
}